import React from 'react';
import clsx from 'clsx';
import DataModelsDropdown from './DataModelsDropdown';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';
import Events from '../hooks/events';

const DatasetDataModelDropdown = ({
  category,
  className,
  code,
  name,
}) => {
  const { dataModel, error, readStatus } = Selectors.useDatasetDataModelDropdown({ category, code });
  Fetch.useFetchDatasetDataModel({ category, code }, readStatus);
  const onChange = Events.useUpdateDatasetDataModel(category, { code, name });

  return (
    <DataModelsDropdown
      className={clsx('aridhia-data-model-dropdown', 'max-content', className)}
      dataModel={dataModel}
      entity="settings"
      error={error}
      fluid
      onChange={onChange}
      readStatus={readStatus}
      showHidden
    />
  );
};

export default DatasetDataModelDropdown;
